import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Copy, ListChecks, MoreHorizontal, Reply } from "lucide-react";
import { useTranslation } from "@ferrivia/i18n";
import s from "./MessageMenu.module.css";

export interface MessageMenuProps {
  triggerClassName?: string;
  onReply?: () => void;
  onCopy: () => void;
  onCreateAction?: () => void;
}

export function MessageMenu({ triggerClassName, onReply, onCopy, onCreateAction }: MessageMenuProps) {
  const { t } = useTranslation("clinic");
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={triggerClassName}
        aria-label={t("messageMenu.label", "More message actions")}
      >
        <MoreHorizontal size={16} aria-hidden="true" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className={s.menu} align="end" sideOffset={4}>
          {onReply ? (
            <DropdownMenu.Item className={s.item} onSelect={onReply}>
              <Reply size={15} aria-hidden="true" />
              {t("messageMenu.reply", "Reply")}
            </DropdownMenu.Item>
          ) : null}
          <DropdownMenu.Item className={s.item} onSelect={onCopy}>
            <Copy size={15} aria-hidden="true" />
            {t("messageMenu.copy", "Copy text")}
          </DropdownMenu.Item>
          {onCreateAction ? (
            <>
              <DropdownMenu.Separator className={s.separator} />
              <DropdownMenu.Item className={`${s.item} ${s.strong}`} onSelect={onCreateAction}>
                <ListChecks size={15} aria-hidden="true" />
                {t("messageMenu.createAction", "Create action…")}
              </DropdownMenu.Item>
            </>
          ) : null}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
